<template>
  <div>
    <header style="display: flex; align-items: center;">
			<h1><a href="javascript:void(0)" @click="goMenu('/home')" class="logo"></a></h1>
      <div style="right: 50px; position: absolute;">
        <button v-if="!showPwd" class="btn btn_type_01 font13" style="margin-left: 5px;margin-right: 5px;width: 120px;" @click="getPwd">비밀번호 확인하기</button>
        <span v-else class='blink' style="margin-right: 20px">{{recyclePassData.reclTrckPinnVal}}</span>
      </div>
      <a v-if="false" class="menu" @click="openSitemap">
				<span></span>
				<span></span>
				<span></span>
			</a>
			<nav>
          <ul>
            <li v-for="menu in menuList" v-bind:key="menu.menuId" @click="goMenu(menu.menuUrlAddr)">
              <a class="depth-1" href="javascript:void(0)" @click="viewSubMenu">{{ menu.menuNm }}</a>
              <ul v-if="menu.menuList.length > 0" class="depth-2">
              <li v-for="subMenu in menu.menuList" v-bind:key="subMenu.menuId" @click="goMenu(subMenu.menuUrlAddr)">
                  <a href="javascript:void(0)">{{ subMenu.menuNm }}</a>
                </li>
              </ul>
            </li>
          </ul>
			</nav>
			<div class="allmenu" >
        <span class="logout" @click="logout"></span>
      </div>
    </header>
    <!-- 전체메뉴 Start -->
  </div>
</template>

<script>
import router from '@/router'
import AppConfig from '@/config'
import ChangePasswordPopup from '@/views/common/ChangePasswordPopup.vue'
import DxSelectBox from 'devextreme-vue/select-box'
import localedata from '../locale/bos-locale'
import bosdictko from '../locale/bos-dict-ko'
import bosdicten from '../locale/bos-dict-en'
import purchaseko from '../locale/purchase/purchase-dict-ko'
import purchaseen from '../locale/purchase/purchase-dict-en'

import { locale, loadMessages, formatMessage } from 'devextreme/localization'
import SideMenu from '@/components//SideMenu'

import isEmpty from 'lodash/isEmpty'

export default {
  name: 'topMenu',
  components: { DxSelectBox, SideMenu, ChangePasswordPopup},
  created () {
    this.locale = localedata.getLocale(),
    this.localeName = localedata.getLocaleName(),
    this.initMessages()
    locale(this.locale)
  },
  data () {
    return {
      topMenuTitle: '',
      menuTitle: '',
      locale: null,
      localeName: '',
      autoMenuInput: '',
      locales: localedata.getLocales(),
      selectBoxInputAttr: { id: 'selectInput' },
      menuList: null,
      autoMenuList: null,
      navigationBigList: [],
      pageIndex: 0,
      showPwd: false,
      recyclePassData: {
        reclTrckPinnVal: ''
      }
    }
  },
  mounted: function () {
    // 메뉴 목록
    window.$store
      .dispatch('TopMenu/load')
      .then(() => {
        this.menuList = window.$store.getters['TopMenu/getMenuList']
      })
    window.$store
      .dispatch('TopMenu/autoMenu')
      .then(() => {
        this.autoMenuList = window.$store.getters['TopMenu/getAutoMenuList']
      })

    this.$nextTick(function () {
      // 네비게이션 스크롤 처리
      $(window).on('scroll', function (e) {
        var sc_postion = $(this).scrollTop()

        $('.location,.latest_menu').toggleClass('on', (sc_postion > 136))
      })

      // sideMemu event
      var $lnbClose = $('.lnb_wrap > .close'),
        $lnbMenu = $('.lnb_wrap .lnb_menu'),
        $cnt = $('.container .contents')

      $('.side').addClass('active')
      $('.lnb_wrap .close').addClass('active')
      $lnbMenu.addClass('active')
      $cnt.removeClass('active')
      $lnbClose.on('click', function () {
        $('.side').addClass('active')
        $('.lnb_wrap .close').addClass('active')
        $lnbMenu.addClass('active')
        $cnt.removeClass('active')
      })
      $lnbMenu.on('click', function () {
        $(this).addClass('active')
        $(this).removeClass('active')
        $('.side').removeClass('active')
        $('.lnb_wrap .close').removeClass('active')
        $cnt.addClass('active')
      })

      var $utilLi = $('.util > li:not(.search,.logout)')
      $utilLi.on('click', function () {
        $(this).find('ul').toggleClass('active')
        $(this).siblings('li').find('ul').removeClass('active')
      })
    })
  },
  beforeUpdate () {
    this.$nextTick(function () {
      this.menuTitle = window.$store.getters['TopMenu/getLowMenuName']
      this.topMenuTitle = window.$store.getters['TopMenu/getRootMenuName']
    })
  },
  computed: {
    cachedComponentList () {
      return window.$store.getters['LatestMenu/getCachedComponentList']
    },
    filterList () {
      const str = this.autoMenuInput
      const reg = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9|\s]/.test(str)
      var count = 0
      var nullCount = 0
      if (reg === false && str !== '' && str !== ' ') {
        return this.autoMenuList.filter((el) => {
          count++
          if (el.menuNm.match(str) == null) {
            nullCount++
          }
          var matchCount = count - nullCount
          if (matchCount > 0) {
            $('.sh_result').addClass('active')
            $('.header_sh_input').parent().siblings('li').find('ul').removeClass('active')
          } else {
            $('.sh_result').removeClass('active')
          }
          return el.menuNm.match(str)
        })
      } else {
        $('.sh_result').removeClass('active')
      }
    },
    // 사용자 이름
    userNm () {
      return window.$store.getters['Login/getUserNm']
    },
    // login id
    userId () {
      return window.$store.getters['Login/getUserId']
    },
    // navigation
    navigation () {
      return window.$store.getters['TopMenu/getNavigation']
    },
    middleMenuList () {
      return window.$store.getters['TopMenu/getMiddleMenuList']
    },
    navigationMiddleList () {
      var middleList = window.$store.getters['TopMenu/getNavigationMiddleList']
      return middleList
    },
    navigationSmallList () {
      return window.$store.getters['TopMenu/getNavigationSmallList']
    },
    // 최근 메뉴
    latestMenuList () {
      return window.$store.getters['LatestMenu/getLatestMenuList']
    },
    // 현재 페이지 tab index
    current () {
      return window.$store.getters['LatestMenu/getCurrent']
    },
    routePath () {
      return this.$route.path
    },
    getStoreAtmInfo () {
      return window.$store.getters['AtmWsStore/getResAtmInfo']
    },
    isConnectedAtm () {
      return !isEmpty(this.getStoreAtmInfo)
    }
  },
  methods: {
    logout () {
      window.$store
        .dispatch('Login/logout')
        .then(() => {
          router.push('/')
        })

      window.localStorage.removeItem('autoLoginToken')
    },
    moveLatestMenu (type) {
      window.$store.dispatch('LatestMenu/moveLatestMenu', { type: type})
    },
    selectTab (goToName) {
      this.$router.push({ name: goToName })
    },
    deleteTab (goToName) {
      window.$store.dispatch('LatestMenu/deleteLatestMenu', { name: goToName })
    },
    activeNavi (e) {
      $('#' + e.target.id).toggleClass('active').siblings().removeClass('active')
    },
    viewSubMenu (e) {
      $(e.target).next('.depth-2').toggleClass('on')
    },
    hideSubMenu () {
      $('.gnb_menu >li > div').hide()
    },
    openSitemap () {
      $('header').toggleClass('on')
    },
    closeSitemap () {
      $('#div_sitemap').fadeOut()
    },
    openPage () {
      window.open('#' + this.$router.history.current.fullPath, '_blank')
    },
    goMenu (menuUrlAddr) {
      if (menuUrlAddr != null && menuUrlAddr != undefined && menuUrlAddr != '') {
        if (this.routePath !== menuUrlAddr) {
          this.autoMenuInput = ''
          if (menuUrlAddr == '/home') {
            this.menuTitle = 'Main'
          }
          this.$router.push({path: menuUrlAddr})
        } else {
          this.$router.go(0)
        }
      } else {
        this.$router.go(0)
      }
      // $('header').toggleClass('on')
    },
    open (val) {
      val.menuUrlAddr
      this.topMenuTitle = val.menuNm
      this.$refs.SideMenu.open(val.menuList)
    },
    selectionLowMenu (e) {
      window.$store.dispatch('TopMenu/changeActive', window.$store.getters['TopMenu/getChangeActive'] + 1)
      this.menuTitle = window.$store.commit('TopMenu/setLowMenuName', {lowMenuName: e})
      this.menuTitle = e
    },
    sideMemuMount () {
      window.$store.dispatch('TopMenu/changeActive', window.$store.getters['TopMenu/getChangeActive'] + 1)
      this.$refs.SideMenu.open(window.$store.getters['TopMenu/getMiddleMenuList'])
    },
    closeSideMemu () {
      window.$store.dispatch('TopMenu/changeActive', window.$store.getters['TopMenu/getChangeActive'] + 1)
    },
    menuInput (e) {
      this.autoMenuInput = e.target.value
    },
    initMessages () {
      loadMessages(bosdictko.getDictionary())
      loadMessages(bosdicten.getDictionary())
      loadMessages(purchaseko.getDictionary())
      loadMessages(purchaseen.getDictionary())
    },
    changePwd () {
      this.$modal.show('changePasswordPopup', {userId: this.userId})
    },
    changeLocale (e) {
      let params = {
        locale: e.Value
      }
      window.$http
        .get('/api/appmgmt/common/changeLocale', {params: params})
        .then((response) => {
          if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
          }
        })
      localedata.setLocale(e.Value)
      localedata.setLocaleName(e.Label)
      document.location.reload()
    },
    getPwd () {
      window.$http
        .get('/api/purchase/atm/recycle/pass')
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            this.showPwd = true
            if (response.data.result === undefined) {
              this.recyclePassData = {
                reclTrckPinnVal: '담당자에게 문의'
              }
            } else {
              this.recyclePassData = response.data.result
            }
          }
        })
    },
    formatMessage: formatMessage
  }
}
</script>

<style scoped>
  @keyframes blink {
    0% {
      color: #bd2406;
    }
    50% {
      color: #f96c0e;
    }
    100% {
      color: #8041d9;
    }
  }
  .blink {
    color: #f96c0e;
    animation: blink 0.5s infinite;
  }
</style>



// WEBPACK FOOTER //
// src/components/TopMenu.vue